import { Box, Checkbox, Divider, FormControlLabel, Grid, Theme, Typography } from '@mui/material';
import { ApplicationProps } from '../../redux-store/types/api-types';
import { KeyValue } from './personalDetails';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import { useEffect, useState } from 'react';
import { LocationType, mdmsLocationList } from '../../redux-store/types/mdms';
import { getLocationList } from '../../redux-store/actions';
import { PHYSICAL_DIGITAL_FLOW } from '../../utils/constant';

export default function ServiceDetails({ application }: {
    application: ApplicationProps
}): JSX.Element {
    return (
        <>
            <Box
                sx={(theme: Theme) => ({
                    bgcolor: 'white',
                    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                    borderRadius: '10px',
                    border: `1px solid ${theme.palette.grey[100]}`,
                    padding: { xs: "15px", sm: '25px' },
                    mb: 4
                })}>
                <Box>
                    <Grid container>
                        <Grid item xs={12}>
                            <Typography sx={(theme: Theme) => ({ fontSize: 18, fontWeight: 700, color: theme.palette.primary[900], mb: '9px' })}>
                                Service Details
                            </Typography>
                            <Box sx={{ mt: 3 }}>
                                <Typography variant="body_500" color='text.secondary'>Email</Typography>
                                <Typography variant="body_500">support@thriveiti.com</Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Box >
        </>
    );
}
